var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCartIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5856",
    "data-name": "Group 5856",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.864,
    height: 32.356,
    viewBox: "0 0 24.864 32.356",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5855",
    "data-name": "Group 5855",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M445.744,183.27c2.059,0,4.12.058,6.176-.019A2.389,2.389,0,0,1,454.4,186.3c-.622,2.49-1.171,5-1.765,7.5a2.24,2.24,0,0,1-2.213,1.757q-5.555.012-11.11,0a2.278,2.278,0,0,1-2.239-1.856c-.738-3.243-3.994-17.921-4.728-21.165a.838.838,0,0,0-.54-.655c-.546-.229-1.078-.489-1.612-.744a.88.88,0,1,1,.726-1.6q.917.41,1.828.838a2.2,2.2,0,0,1,1.265,1.555c.5,2.153,3.495,15.746,3.987,17.9.264,1.153.524,2.307.792,3.459a.565.565,0,0,0,.637.515q5.437,0,10.875,0a.574.574,0,0,0,.642-.508q.876-3.75,1.75-7.5c.112-.48-.125-.762-.65-.763-1.387,0-2.775,0-4.162,0q-4.28,0-8.559,0a.962.962,0,0,1-.908-.39.83.83,0,0,1-.047-.89.847.847,0,0,1,.79-.475c.929,0,1.857,0,2.786,0Z",
    transform: "translate(-429.627 -169.43)",
    fill: "#ff6e1d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M455.105,236.047a2.244,2.244,0,1,1-2.279-2.232A2.242,2.242,0,0,1,455.105,236.047Zm-1.413.019a.829.829,0,1,0-.835.828A.828.828,0,0,0,453.692,236.066Z",
    transform: "translate(-441.533 -205.951)",
    fill: "#ff6e1d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M468.684,236.059a2.234,2.234,0,0,1,2.23-2.245,2.246,2.246,0,1,1,0,4.493A2.236,2.236,0,0,1,468.684,236.059Zm2.25.834a.833.833,0,1,0-.024-1.667.833.833,0,0,0,.024,1.667Z",
    transform: "translate(-451.781 -205.951)",
    fill: "#ff6e1d",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCartIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cart-Icon.e7f789dda15500199c0ee5f4ee4f5596.svg";